import { useMemo, useState } from "react"
import { useQueryState } from "nuqs"
import usePagination from "../../hooks/usePagination"
import ReportRoutingLogsTable from "./components/ReportRoutingLogsTable"
import { generateFilter } from "../../utils"
import { useReportRoutingLogs } from "../../hooks/useReportRoutingLogs"
import ApiError from "../../components/ApiError"

const ReroutedReports = () => {
  const { limit, onPaginationChange, page, pagination } = usePagination()
  const [sorting, setSorting] = useState([{ id: "createdAt", desc: true }])
  const [issuer, setIssuer] = useQueryState("issuer", { defaultValue: "" })
  const [createdAt, setCreatedAt] = useQueryState("createdAt", {
    defaultValue: "",
  })

  const filters = useMemo(() => {
    const next = []
    if (issuer) next.push({ id: "PatientIssuer", value: issuer })
    if (createdAt) next.push({ id: "createdAt", value: createdAt })
    return next
  }, [issuer, createdAt])

  const setFilters = (updater) => {
    const nextArr = typeof updater === "function" ? updater(filters) : updater
    const nextIssuer =
      nextArr.find((f) => f.id === "PatientIssuer")?.value ?? ""
    const nextCreatedAt = nextArr.find((f) => f.id === "createdAt")?.value ?? ""
    setIssuer(nextIssuer || null)
    setCreatedAt(nextCreatedAt || null)
  }

  const { data, isLoading, isError, error } = useReportRoutingLogs({
    page,
    limit,
    sortBy: sorting.map((s) => `${s.id}:${s.desc ? "DESC" : "ASC"}`).join(","),
    ...(generateFilter(filters) || {}),
  })

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <>
      <div className="px-4 py-2 flex justify-between items-center mt-2">
        <h1 className="text-2xl font-bold">Re-Routed Reports</h1>
      </div>
      <ReportRoutingLogsTable
        data={isLoading ? [] : data.data}
        filters={filters}
        loading={isLoading}
        pageCount={isLoading ? 0 : data.totalPages}
        pagination={pagination}
        setFilters={setFilters}
        setSorting={setSorting}
        sorting={sorting}
        onPaginationChange={onPaginationChange}
      />
    </>
  )
}

export default ReroutedReports
